{
    "Accessibility menu": "ಪ್ರವೇಶಮಾಡುವಿಕೆ ಮೆನು",
    "Close": "ಮುಚ್ಚಿ",
    "Content adjustments": "ವಿಷಯದ ಹೊಂದಾಣಿಕೆಗಳು",
    "Navigation adjustments": "ನ್ಯಾವಿಗೇಶನ್ ಹೊಂದಾಣಿಕೆಗಳು",
    "Text Align": "ಪಠ್ಯ ಜೋಡಣೆ",
    "Align Left": "ಎಡಕ್ಕೆ ಜೋಡಿಸಿ",
    "Align Center": "ಮಧ್ಯಕ್ಕೆ ಜೋಡಿಸಿ",
    "Align Right": "ಬಲಕ್ಕೆ ಜೋಡಿಸಿ",
    "Adjust Font Size": "ಅಕ್ಷರದ ಗಾತ್ರವನ್ನು ಹೊಂದಿಸಿ",
    "Highlight Title": "ಶೀರ್ಷಿಕೆಯನ್ನು ಹೈಲೈಟ್ ಮಾಡಿ",
    "Highlight Links": "ಲಿಂಕ್‌ಗಳನ್ನು ಹೈಲೈಟ್ ಮಾಡಿ",
    "Readable Font": "ಓದಲು ಸುಲಭವಾದ ಅಕ್ಷರಶೈಲಿ",
    "Colour adjustments": "ಬಣ್ಣ ಹೊಂದಾಣಿಕೆಗಳು",
    "Dark Contrast": "ಗಾಢ ವ್ಯತ್ಯಾಸ",
    "Light Contrast": "ತಿಳಿ ವ್ಯತ್ಯಾಸ",
    "High Contrast": "ಹೆಚ್ಚು ವ್ಯತ್ಯಾಸ",
    "High Saturation": "ಹೆಚ್ಚು ಸ್ಯಾಚುರೇಶನ್",
    "Low Saturation": "ಕಡಿಮೆ ಸ್ಯಾಚುರೇಶನ್",
    "Monochrome": "ಏಕವರ್ಣ",
    "Tools": "ಉಪಕರಣಗಳು",
    "Reading Guide": "ಓದುವ ಮಾರ್ಗದರ್ಶಿ",
    "Big Cursor": "ದೊಡ್ಡ ಕರ್ಸರ್",
    "Increase Font Size": "ಅಕ್ಷರದ ಗಾತ್ರವನ್ನು ಹೆಚ್ಚಿಸಿ",
    "Decrease Font Size": "ಅಕ್ಷರದ ಗಾತ್ರವನ್ನು ಕಡಿಮೆ ಮಾಡಿ",
    "Letter Spacing": "ಅಕ್ಷರಗಳ ನಡುವಿನ ಅಂತರ",
    "Line Height": "ಸಾಲಿನ ಎತ್ತರ",
    "Font Weight": "ಅಕ್ಷರದ ತೂಕ",
    "Dyslexia Font": "ಡಿಸ್ಲೆಕ್ಸಿಯಾ ಅಕ್ಷರಶೈಲಿ",
    "Language": "ಭಾಷೆ",
    "Accessibility widget": "ಪ್ರವೇಶಮಾಡುವಿಕೆ ಮೆನು ಅನ್ನು ತೆರೆಯಿರಿ",
    "Accessibility Profiles": "ಪ್ರವೇಶಮಾಡುವಿಕೆ ಪ್ರೊಫೈಲ್‌ಗಳು",
    "Cognitive Disability": "ಜ್ಞಾನಾತ್ಮಕ ಅಂಗವೈಕಲ್ಯ",
    "Seizure Safe": "ಅಪಸ್ಮಾರಕ್ಕೆ ಸುರಕ್ಷಿತ",
    "Accessibility statement": "ಪ್ರವೇಶಮಾಡುವಿಕೆ ಹೇಳಿಕೆ",
    "ADHD": "ADHD",
    "Low Vision": "ಕಡಿಮೆ ದೃಷ್ಟಿ",
    "Pause Animations": "ಅನಿಮೇಶನ್‌ಗಳನ್ನು ನಿಲ್ಲಿಸಿ",
    "Animation paused": "ಅನಿಮೇಶನ್ ವಿರಾಮಗೊಳಿಸಲಾಗಿದೆ",
    "Reset all settings": "ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಮರುಹೊಂದಿಸಿ",
    "Shortcut:": "ಶಾರ್ಟ್‌ಕಟ್:",
    "Epilepsy Safe Mode": "ಅಪಸ್ಮಾರ ಸುರಕ್ಷಿತ ಮೋಡ್",
    "Mute sounds": "ಶಬ್ದಗಳನ್ನು ಮ್ಯೂಟ್ ಮಾಡಿ",
    "Page read": "ಪುಟವನ್ನು ಓದಿ",
    "Page read controls": "ಪುಟ ಓದುವ ನಿಯಂತ್ರಣಗಳು",
    "Pause": "ವಿರಾಮ",
    "Resume": "ಮುಂದುವರಿಸಿ",
    "Stop": "ನಿಲ್ಲಿಸಿ",
    "Settings": "ಸೆಟ್ಟಿಂಗ್‌ಗಳು",
    "Speed": "ವೇಗ",
    "Voice": "ಧ್ವನಿ",
    "Close accessibility menu": "ಪ್ರವೇಶಿಸುವಿಕೆ ಮೆನುವನ್ನು ಮುಚ್ಚಿ",
    "Back to accessibility menu": "ಪ್ರವೇಶಿಸುವಿಕೆ ಮೆನುಗೆ ಹಿಂತಿರುಗಿ",
    "Search languages": "ಭಾಷೆಗಳನ್ನು ಹುಡುಕಿ",
    "Selected language": "ಆಯ್ಕೆ ಮಾಡಿದ ಭಾಷೆ",
    "View accessibility statement (opens in new window)": "ಪ್ರವೇಶಿಸುವಿಕೆ ಹೇಳಿಕೆಯನ್ನು ವೀಕ್ಷಿಸಿ (ಹೊಸ ವಿಂಡೋದಲ್ಲಿ ತೆರೆಯುತ್ತದೆ)",
    "Visit CookieYes website (opens in new window)": "CookieYes ವೆಬ್‌ಸೈಟ್‌ಗೆ ಭೇಟಿ ನೀಡಿ (ಹೊಸ ವಿಂಡೋದಲ್ಲಿ ತೆರೆಯುತ್ತದೆ)",
    "Reset all accessibility settings to default": "ಎಲ್ಲಾ ಪ್ರವೇಶಿಸುವಿಕೆ ಸೆಟ್ಟಿಂಗ್‌ಗಳನ್ನು ಡೀಫಾಲ್ಟ್‌ಗೆ ಮರುಹೊಂದಿಸಿ"
}
